import { Accordion } from '@gds/Accordion/Accordion';
import { ChevronRight } from '@gds/Icons/Paths/ChevronRight';

import { FinanceSummaryRow } from '../FinanceSummaryRow/FinanceSummaryRow';
import { RepresentativeExampleList } from '../RepresentativeExampleList/RepresentativeExampleList';
import type { FinanceSummaryProps } from './FInanceSummary.entities';

import styles from './FinanceSummary.module.css';

export const FinanceSummary = ({ finance, strings }: FinanceSummaryProps) => {
  return (
    <div className={styles.wrapper}>
      <FinanceSummaryRow finance={finance} strings={strings} />

      <Accordion
        title={strings.financeSummaryRepresentativeExample}
        hideArrow
        customRightElement={<ChevronRight fontSize={16} className={styles.chevron} />}
        className={styles.accordion}
      >
        <RepresentativeExampleList finance={finance} />
      </Accordion>
    </div>
  );
};
